module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/modal-profile-2-image-9f8cd776fd962b67a368d6a7ffdc7903.png";